var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrezor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "trezor",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 33.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M11.638,0a8.376,8.376,0,0,0-8.38,8.38v3.141C1.631,11.816,0,12.208,0,12.718V29.109a.772.772,0,0,0,.509.668c1.846.748,9.11,3.318,10.778,3.907a.834.834,0,0,0,.332.079.767.767,0,0,0,.332-.079c1.669-.589,8.951-3.16,10.8-3.907a.78.78,0,0,0,.491-.65V12.718c0-.509-1.608-.921-3.239-1.2V8.38A8.357,8.357,0,0,0,11.638,0Zm0,4.006a4.036,4.036,0,0,1,4.379,4.379v2.73a59.489,59.489,0,0,0-8.754,0V8.385A4.033,4.033,0,0,1,11.638,4.006Zm-.019,11.129c3.809,0,7.006.294,7.006.823V26.183c0,.159-.019.178-.159.234s-6.5,2.356-6.5,2.356a2.175,2.175,0,0,1-.332.079,1.728,1.728,0,0,1-.332-.1s-6.361-2.295-6.5-2.356-.159-.079-.159-.234V15.938C4.613,15.41,7.81,15.134,11.619,15.134Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3222",
    transform: "translate(29.956 10.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path13",
    d: "M55.464,64.3V53.1H51.372V49.085H64.13V53.1H60.078V64.3Z",
    transform: "translate(-51.372 -48.839)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path15",
    d: "M89.177,64.3l-2.1-4.784H85.407V64.3H80.792V49.085h8.121c3.565,0,5.477,2.363,5.477,5.213a4.9,4.9,0,0,1-2.738,4.615L94.408,64.3H89.177Zm.545-10c0-.826-.733-1.184-1.5-1.184H85.407v2.4h2.814C88.99,55.5,89.722,55.142,89.722,54.3Z",
    transform: "translate(-66.082 -48.839)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M112.831,64.3V49.085h11.539V53.1h-6.942v1.5H124.2v4.016h-6.772v1.671h6.942V64.3H112.831Z",
    transform: "translate(-82.101 -48.839)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "M140.705,64.335V60.677l5.8-7.541h-5.8V49.12h11.874v3.623l-5.816,7.581h5.986V64.34Z",
    transform: "translate(-96.039 -48.857)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M167.044,56.473c0-4.673,3.623-7.88,8.331-7.88,4.69,0,8.331,3.19,8.331,7.88,0,4.673-3.623,7.862-8.331,7.862S167.044,61.146,167.044,56.473Zm11.972,0a3.662,3.662,0,1,0-3.659,3.81A3.607,3.607,0,0,0,179.015,56.473Z",
    transform: "translate(-109.208 -48.593)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "M212.613,64.335l-2.1-4.784h-1.671v4.784h-4.615V49.12h8.121c3.565,0,5.477,2.363,5.477,5.213a4.9,4.9,0,0,1-2.738,4.615l2.756,5.383h-5.231Zm.563-10.02c0-.826-.733-1.184-1.5-1.184H208.86v2.4h2.814C212.447,55.517,213.176,55.16,213.176,54.316Z",
    transform: "translate(-127.8 -48.857)",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrezor);
export default __webpack_public_path__ + "static/media/trezor.062495dd.svg";
export { ForwardRef as ReactComponent };